// Magyar - hu - 匈牙利语
const hu = {
  home: {
    home: 'Kezdőlap',
    solutions: 'Megoldások',
    support: 'Támogatás',
    news: 'Hírek',
    aboutUs: 'Rólunk',
    contactUs: 'Kapcsolat',
    cgm: 'CGM',
    download: 'Letöltések',
    helpCenter: 'Súgóközpont',
    copyText: '© 2026 HIPPO MEDICAL PTE. LTD. Minden jog fenntartva.',
    menu: 'Menü',
    quickLinks: 'Gyors linkek',
    contact: 'Kapcsolat',
    legal: 'Jogi információ',
    termsUse: 'Felhasználási feltételek',
    privacyPolicy: 'Adatvédelmi irányelvek',
    portal: 'Felhasználói portál',
    hClinic: 'H-Clinic',
    emailPlaceholder: 'E-mail',
    subscribe: 'Feliratkozás',
    signUp: 'Iratkozzon fel a legfrissebb hírekért',
    downloadApp: 'Alkalmazás letöltése',
    blogNews: 'Blog és hírek',
    latestArticles: 'Legfrissebb cikkek',
    viewAllArticles: 'Összes cikk megtekintése',
    empower: 'Támogatjuk az egészségtudatos mindennapokat',
    empowerList1Content:
      'A Hippo CGM sokkal könnyebbé tette a fiam diabéteszének kezelését. A H-Link segítségével jól átláthatjuk a glükóztrendeket, és magabiztosabban tudjuk alakítani a kezelését. Nagyobb biztonságérzetet ad a mindennapokban.',
    empowerList1Name:
      'Petra N., Csehország (1-es típusú diabéteszes gyermek édesanyja)',
    empowerList2Content:
      'A HiPPO CGM-et stabil működése és hosszabb viselési ideje miatt ajánljuk pácienseinknek. A felhasználói visszajelzések nagyon pozitívak.',
    empowerList2Name: 'Dr. Luca B., endokrinológus, Olaszország',
    empowerList3Content:
      'Nemrég kezdtem el használni a HiPPO CGM-et – kényelmes, pontos, és a riasztások már többször segítettek elkerülni az éjszakai alacsony glükózértékeket. Eddig nagyon elégedett vagyok vele.',
    empowerList3Name: 'Fahad A., Szaúd-Arábia (2-es típusú diabéteszes beteg)',
    reliable: 'Megbízható partnere a diabétesz kezelésében',
    hippoH1: 'HiPPO H1',
    challenges: 'Kihívások',
    constant: 'Folyamatos vércukorszint-ellenőrzés',
    traditional: 'A hagyományos ujjbegyszúrás kényelmetlen és fájdalmas lehet',
    dataOverload: 'Összetett értékek',
    managing:
      'A különböző forrásból származó vércukoradatok kezelése és értelmezése sokszor összetett és nehezen átlátható lehet.',
    treatment: 'Kezelési döntések támogatása',
    accurately:
      'A megfelelő kezelési döntések meghozatala a vércukorértékek alapján gyakran nem egyszerű feladat.',
    lifestyle: 'Életmód és mindennapi egyensúly',
    balancing:
      'Az étkezések, a mozgás és a gyógyszeres kezelés összehangolása a hétköznapokban kihívást jelenthet.',
    hippoCan: 'Hippo bioszenzorok előnyei',
    painless: 'Fájdalommentes és diszkrét monitorozás',
    ourCgm:
      'CGM rendszerünk folyamatos glükózértékeket biztosít ujjbegyszúrás nélkül.',
    realTime: 'Valós idejű adatok és elemzések',
    accessYour:
      'Kövesse glükózadatait kényelmesen okostelefonján, figyelje a trendeket, és hozzon megalapozottabb döntéseket.',
    personalized: 'Személyre szabott támogatás',
    ourCgmSys:
      'A HiPPO H1 alkalmazás riasztásai és emlékeztetői segítenek a kezelési célok követésében és a mindennapi rutin támogatásában.',
    improved: 'Jobb döntéshozatal',
    gain: 'Ismerje meg jobban, hogyan reagál szervezete az egyes eseményekre, étkezésekre vagy aktivitásokra. A valós idejű visszajelzések segítenek a glükózingadozások hatékonyabb kezelésében és a napi rutin tudatosabb alakításában.',
    // about: 'Rólunk',
    companyProfile: 'Vállalati profil',
    banner1Title: 'Üdvözöljük a Hippo Medicalnál',
    banner1Content: 'A CGM innováció élvonalában',
    get banner2Title() {
      return this.banner1Title;
    },
    banner2Content: 'Új szintre emeljük a folyamatos glükózmonitorozást.',
    banner3Content: '24/7 glükózvédelem',
    get banner4Title() {
      return this.banner1Title;
    },
    banner4Content: 'Élen járunk a CGM technológiában',
    // 错误提示
    subscribeSuccess: 'Feliratkozás sikeres', // ai翻译
    subscribeFailed: 'Feliratkozás sikertelen', // ai翻译
    invalidEmail: 'Érvénytelen e-mail cím', // ai翻译
  },
  cgm: {
    get banner1Title() {
      return hu.home.banner1Title;
    },
    get banner1Content() {
      return hu.home.banner4Content;
    },
    whyChoose: 'Miért válassza a HiPPO CGM-et',
    accurate: 'Megbízható pontosság',
    accurateText: 'A harmadik generációs enzimtechnológiának köszönhetően',
    accurateText1: 'stabil és pontos teljesítmény',
    easyUse: 'Egyszerű használat',
    easyUseText: '14 napos folyamatos monitorozás',
    realTime: 'Monitorozás',
    realTimeText: 'Hipoglikémia és hiperglikémia figyelmeztetések',
    realTimeText1:
      'Valós idejű adatmegosztás családtagokkal és egészségügyi szakemberekkel',
    hippo: 'HiPPO',
    hCgm: 'H1 CGM',
    keep: 'Bárhol és bármikor tájékoztat',
    withHippo: 'HiPPO alkalmazással és portállal',
    smallSensors: 'Kisméretű szenzor, kényelmes viselet',
    agpReport:
      'Professzionális AGP jelentések az egészségügyi szakemberek és felhasználók számára',
    unlimitedFollow: 'Korlátlan követés',
    iWatchApp: 'iWatch alkalmazás elérhető',
    certified: 'Gyermekek számára engedélyezett',
    loremIp:
      'A rendszer klinikailag validált és hivatalosan tanúsított 3 év feletti gyermekek számára. Megbízható pontosságot, biztonságos használatot és kényelmes viseletet biztosít a fiatalabb felhasználók számára. A bizonyított szenzorpontosság és a bőrbarát anyaghasználat révén megbízható glükózmonitorozást nyújt gyermekek és serdülők számára, támogatva az egészségügyi szakembereket a magabiztos, adatvezérelt diabéteszgondozásban.',
  },
  news: {
    date: 'Dátum',
    recommendedArticles: 'Ajánlott cikkek',
  },
  support: {
    download: 'Útmutatók letöltése',
    supportDown: 'Támogatás/Letöltések',
  },
  about: {
    // welcome: 'Üdvözöljük a Hippo Medical oldalán',
    // covered: 'Elérhető országok',
    // patents: 'Szabadalmak',
    // features: 'Funkciók',
    // ring: 'Gyűrű',
    // apparently:
    //   'Intelligens gyűrű, amely képes figyelni többek között a véroxigénszintet, a pulzust és az alvást. Emellett algoritmikusan összekapcsolható a CGM rendszerünkkel. Várható megjelenés: 2026. Hamarosan érkezik!',
    // cgmSky:
    //   'Professzionális CGM rendszer, amelyet a felhasználók és az egészségügyi szakemberek igényei alapján fejlesztettek. Magas pontosságot, felhasználóbarát szoftveres élményt és fejlett Hippo Medical algoritmusokat kínál. Megjelenés: 2025 júniusában.',
    // smartWatch: 'Okosóra',
    // byTheSame:
    //   'Viselhető vérnyomásmonitorozó eszköz, amely folyamatosan követi a szisztolés és diasztolés vérnyomást, az átlagos artériás nyomást és egyéb paramétereket a Hippo Medical fejlett algoritmusainak segítségével. Várható megjelenés: 2026.',
    explore: 'Felfedezés',
    hippoPte: 'HIPPO MEDICAL PTE. LTD.',
    paya: '60 PAYA LEBAR ROAD',
    lebar: '#11-53',
    road: 'PAYA LEBAR SQUARE',
    singa: 'SZINGAPÚR (409051)',
    zipCode: 'Irányítószám',
    emailCode: '409051',
    email: 'E-mail',
    emailText: 'info@hippodiabetes.com',
    name: 'Név*',
    company: 'Cég',
    message: 'Üzenet',
    phone: 'Telefon',
    submit: 'Küldés',
    // commingSoon: 'Hamarosan',
    cpInfo1:
      'A Hippo Medical egy globális MedTech vállalat, szingapúri központtal, amely orvosi minőségű viselhető bioszenzorokkal kívánja forradalmasítani a krónikus betegségek kezelését. Célunk a folyamatos monitorozás és a fejlett adatelemzés biztosítása.',
    cpInfo2:
      'Új generációs bioszenzorok és fejlett adatelemző platform fejlesztésével célunk a diagnosztika átalakítása, valamint egy proaktívabb és személyre szabottabb jövő megteremtése.',
    submitFailed: 'Küldés sikertelen', // ai翻译
    get invalidEmail() {
      return hu.home.invalidEmail;
    },
    fillAllFields: 'Kérjük, töltse ki ezt a mezőt', // ai翻译
  },
  download: {
    language: 'Nyelv',
    product: 'Termék',
    unit: 'Mértékegység',
    fetchFailed: 'Lekérés sikertelen', // ai翻译
  },
  help: {
    search: 'Keresés',
    support: 'Támogatás/Súgóközpont/H1 CGM',
    source: 'HiPPO H1 CGM online segédanyagok',
    viewAll: 'Összes megtekintése',
    insert: 'H1 CGM felhelyezése',
    setUp: 'H1 alkalmazás beállítása',
    faq: 'HiPPO H1 CGM GYIK',
    freq: 'Gyakran ismételt kérdések',
    noData: 'Nincs találat..',
    searchKeys: {
      warmUp: 'Bemelegítési hiba',
      waterLeakage: 'Folyadékbejutás',
      lowGlucose: 'Alacsony glükózszint',
      cannotPair: 'Az eszköz nem párosítható a telefonnal',
    },
  },
  faq: {
    faq: 'GYIK',
    general: 'Általános kérdések',
    need: 'Segítségre van szüksége?', // ai翻译
    here: 'Itt találja a leggyakrabban ismételt kérdéseket',
    technical: 'Műszaki kérdések',
  },
  lang: {
    chooseCountry: 'Válassza ki az országot/régiót',
    northAmerica: 'Észak-Amerika', // ai翻译
    southAmerica: 'Dél-Amerika', // ai翻译
    europe: 'Európa', // ai翻译
    africa: 'Afrika', // ai翻译
    asia: 'Ázsia', // ai翻译
    oceania: 'Óceánia', // ai翻译
    other: 'Egyéb', // ai翻译
  },
  aboutMap: {
    suzhou: {
      name: 'Szucsou, Kína',
      subName: 'Gyártóhely',
      hovData:
        'Globális központ, K+F és adatközpont, valamint értékesítési iroda Ázsia és Ausztrália számára',
    },
    dubai: {
      name: 'Dubaj',
      subName: 'Regionális iroda',
      hovData: 'Délkelet-ázsiai értékesítési központ',
    },
    singapore: {
      name: 'Szingapúr',
      subName: 'Központ',
      hovData: 'Délkelet-ázsiai értékesítési csapat',
    },
    sanFrancisco: {
      name: 'San Francisco, USA',
      subName: 'Regionális iroda',
      hovData: 'Észak-amerikai értékesítési központ',
    },
    barcelona: {
      name: 'Barcelona',
      subName: 'Értékesítési iroda',
      hovData:
        'Globális központ, K+F és adatközpont, valamint értékesítési iroda Ázsia és Ausztrália számára',
    },
  },
};
export default hu;
